export default __webpack_public_path__ + "static/media/wideImgCR.dbd80cc8.jpg";